<script setup>
  import {ref, onMounted, reactive} from 'vue'
  import NavigationDataService from '@/services/NavigationDataService'
  import LocalizationDataService from "@/translations/LocalizationDataService";
  import ThlSlideMenuService from "@/services/ThlSlideMenuService";
  import { useConfigStore } from "@/store/config"


  const props = defineProps(['layoutId','level','curLayoutId','useSlideMenu','isSubSiteView'])
  const store = useConfigStore()
  // For controlling visibilty of certain element
  const currentLayoutId = ref(null)
  const curLocale = ref("fi")
  const state = reactive({})
  const parents = ref(null)
  // Nav childs template refs
  const itemsRef = ref([])
  const navSelected = ref(false)
  const navItem = ref(null)
  const navTree = ref(null)
  const navElem = reactive({
    ul: {
      classes: "child-menu"
    }
  })



  // Toggle visibility of children
  const toggleChildren = (index) => {
    const button = itemsRef.value[index].querySelector('button')
    if (button.classList.contains('slide-toggler')) {
      store.setSlideViewActive(true)
      store.setSlideLayoutId(navTree.value[index].navItemId)
    }
    navTree.value[index].attributes.button.ariaExpanded = navTree.value[index].attributes.button.ariaExpanded === 'false' ? 'true' : 'false'
  }

  onMounted(() => {
    currentLayoutId.value = store.getCurrentLayoutId
    // Set current locale
    curLocale.value = LocalizationDataService.getLocale()

    if (props.layoutId !== "") {
        parents.value = store.getParents

        // Get navItems
        NavigationDataService.getChildren(props.layoutId)
            .then((response) => {
              navItem.value = response.data


              // Create nav tree and remove hidden pages
              if (!!navItem.value.children)  {
                  navTree.value = navItem.value.children.filter(e => {
                    if (!e.isHidden) return e
                    if (e.isHidden && e.navItemId === store.getProjectPageLayoutId) {
                      Object.assign(e, { isProjectPage : true })
                      return e
                    }
                  })
                }

                // enhance navTree elements
                navTree.value.forEach(nav => {
                  const attrs = {
                    ul: {
                      classes: "child-menu"
                    },
                    li: {
                      classes: "child-menu-item "
                    },
                    link: {
                      classes: "parent-menu-link-text has-btn"
                    },
                    button : {
                      classes: "child-icon",
                      ariaExpanded: "false",
                      ariaText: {
                        submenu: LocalizationDataService.getText("section-sub-menu")
                      }
                    },
                    ariaCurrent: null
                  }


                  // Add locale prefix to link urls
                  if ( curLocale.value !== "fi") nav.friendlyUrl = `/${curLocale.value}${nav.friendlyUrl}`


                  // Add correct CSS class to LI elements in subsite view
                  if (props.isSubSiteView) {
                    attrs.li.classes += " parent-menu-item "
                  }

                  // Add attributes (classes, texts etc)
                  Object.assign(nav, { attributes : attrs })

                  // Check if page should open slide menu
                  const isThemePage = ThlSlideMenuService.useSlideMenu(nav.name)

                  if (!!nav.isThemePage) Object.assign(nav, { isThemePage : isThemePage })

                  // Check if current page is parent
                  if (parents.value && parents.value.length > 0) {
                    if (parents.value.includes(nav.navItemId)) {
                        nav.attributes.li.classes += " currentpage open"
                        nav.attributes.button.ariaExpanded = 'true'
                    }
                  }

                  // if nav is selected
                  if (nav.navItemId === currentLayoutId.value) {
                    nav.attributes.li.classes  += " currentlast  "
                    nav.attributes.button.ariaExpanded = 'false'
                    nav.ariaCurrent = 'page'
                  }

                  // Add correct CSS classes if uses slide menu
                  if (isThemePage || nav.isThemePage || props.useSlideMenu || !!nav.isProjectPage) {
                    nav.attributes.button.classes = "right-icon open-new-navigation slide-toggler"
                    nav.attributes.li.classes = "child-menu-item parent-sub  "
                  }

                  // Check if is project page
                  if (!!nav.isProjectPage) {
                    // if project main page is active
                    if (nav.navItemId === currentLayoutId.value) {
                      nav.attributes.li.classes  += " currentlast icon--white "
                    } else {
                      nav.attributes.li.classes += " currentpage "
                    }
                  }


                })
            })
            .catch((e) => {
              console.log(e)
            })
      }
  })

</script>
<template>
    <ul v-if="!!navTree" :class="navElem.ul.classes">
      <li v-for="(navChild,index) in navTree" :class="navChild.attributes.li.classes" :data-nav-item="navChild.navItemId" :key="navChild.navItemId" ref="itemsRef">
          <a
              :href="navChild.friendlyUrl"
              :class="navChild.attributes.link.classes"
              :aria-current="navChild.ariaCurrent"
          ><span v-html="navChild.name"></span></a>

          <template v-if="navChild.hasChildren">
            <button
                  :class="navChild.attributes.button.classes"
                  :aria-expanded="navChild.attributes.button.ariaExpanded"
                  @click="toggleChildren(index)"
            >
              <span class="sr-only">{{ navChild.name }} {{ navChild.attributes.button.ariaText.submenu }}</span>
            </button>
            <NavIterator
                v-if="navChild.attributes.button.ariaExpanded === 'true'"
                :isSubsiteView="props.isSubSiteView"
                :layout-id="navChild.navItemId"
                :level="props.navLevel + 1"
                :cur-layout-id="props.curLayoutId"
                :use-slide-menu="navChild.isThemePage"
            />
          </template>
      </li>
    </ul>
</template>